import { isChrome } from "./isChrome";
import jqueryUi from "../../../libraries/jquery-ui.min";


export default function search() {
  jqueryUi();
  InitAC();
  var chromeStatus = isChrome();
  var selectedUiItem;

  $(function () {
    $(".search_phrase").on("keyup", function (event) {
      if ($(this).val().trim().length > 0) {
        if (event.which === 13 && (!selectedUiItem || !selectedUiItem.url)) {
          search();
        }

        $(this).removeClass('error');
      }
    });
    $(".search_phrase").on("keydown", function (event) {
      if (!chromeStatus) {
        if (event.which == 34) {
          if (isIE()) {
            if ($(this).is(":focus")) {
              $(this).blur();
            }
          }
          else {
            window.scrollTo(0, $(document).scrollTop() + (window.innerHeight * 0.9));
          }
        }
        else if (event.which == 33) {
          if (isIE()) {
            if ($(this).is(":focus")) {
              $(this).blur();
            }
          }
          else {
            window.scrollTo(0, $(document).scrollTop() - (window.innerHeight * 0.9));
          }
        }
      }
    });

    $(".search_phrase").on("click", function (event) {
      if ($(this).val().length == 0) {
        $(".search_phrase").catcomplete("search", "");
      }
    });
    jQuery.ui.autocomplete.prototype._resizeMenu = function () {
      var ul = this.menu.element;
      ul.outerWidth(this.element.outerWidth());
    }

    $(".quick-search-textbox").on("keyup", function (event) {
      if ($(this).val().trim().length > 0) {
        if (event.which == 13) {
          search($(this).val());
        }
      }
    });

    $('.search-form .search_phrase').focus();
    $('.search-form .search-item').focus();

    $('#btnSearch').on('click', function () {
      search();
    })

    $('.zero-search-result-func').on('click', function() {
      zeroSearchResultSubmit();
    })
  });

  function InitAC() {

    $.widget("custom.catcomplete", $.ui.autocomplete, {
      _create: function () {
        this._super();
        this.widget().menu("option", "items", "> :not(.ui-autocomplete-category):not(.autocomplete-clear)");
      },
      _renderMenu: function (ul, items) {
        var self = this;
        $.each(items, function (index, item) {
          self._renderItemData(ul, item);
        });
      },
      _renderItem: function (ul, item) {
        var category = "&nbsp;-" + item.category.toLowerCase();

        if (item.type === "search") {
          category = "&nbsp;&nbsp;<svg width='11px' height='11px'><use xlink:href = '/images/sprite.svg#search-autocomplete'></use></svg>";
        }

        var _item = $("<li class='ui-corner-all'></li>")
          .data("item.autocomplete", item)
          .append("<a href='javascript:void(0)'><span>" + item.label + "<i class='autocomplete-item-category'>" + category + "</i></span></a>")
          .appendTo(ul);

        var prodItem = _item.find("a");
        prodItem.attr("href", item.url);

        if (item.artist && item.artist !== '') {
          var prodItemText = prodItem.find("span");
          prodItemText.html("<b>" + item.artist + "</b><br/>" + prodItemText.html());
        }

        if (item.image && item.image !== '') {
          prodItem.addClass("product-suggestions");
          prodItem.prepend(
            "<span class='img-holder'>" +
            "<img class='product-suggestions-image' loading=lazy src='" + item.image + "'  alt='" + item.label + "'/>" +
            "</span>"
          );
        }

        return _item;
      },

    });

    $(".search_phrase").attr('autocorrect', 'off');

    $(".search_phrase").catcomplete({
      delay: 0,
      minLength: 0,
      search: function (event, ui) {
        if (["ArrowUp", "ArrowDown", "ArrowLeft", "ArrowRight"].indexOf(event.key) > -1) { event.preventDefault();; }
      },
      source: function (request, response) {
        if ($(".search_phrase").val().length == 0) {
          $.ajax({
            url: "/api/Apptus/TopSearches",
            success: function (data) {
              if (typeof (data) != "undefined" && data.length) {
                response(data);
              }
            }
          });
        }
        else {
          $.ajax({
            data: { "searchPrefix": request.term },
            url: "/api/Apptus/Autocomplete",
            success: function (data) {
              if (typeof (data) != "undefined" && typeof (data.Result) != "undefined" && data.Result != "0") {
                $('.ui-autocomplete').addClass(data.cssTicket);
                response($.map(data.Result, function (item) {
                  return {
                    label: item.Text,
                    category: item.Category,
                    type: item.Type,
                    url: item.Url,
                    image: item.Image,
                    artist: item.Artist
                  }
                }));
              }
              else { response(); }
            }
          });
        }
      },
      select: function (event, ui) {
        if (event.type === "catcompleteselect") {
          selectedUiItem = ui.item;

          if (ui.item.url && event.which === 13) {
            window.location.href = ui.item.url;
          }
          $(".search_phrase").val(ui.item.label);
        }
        return false;
      },
      close: function (event, ui) {
        $("body").removeClass("search-autocomplete-open");
        if (event.type === "catcompleteclose" && (!selectedUiItem || !selectedUiItem.url)) {
          //1  = The left mouse button was clicked.
          //13 = The Enter key was pressed.
          if (event.which === 1 || event.which === 13) {
            search();
          }
        }
        return false;
      },
      open: function (result) {
        if (navigator.userAgent.match(/(iPod|iPhone|iPad)/)) {
          $('.ui-autocomplete').off('menufocus hover mouseover');
        }
        $("body").addClass("search-autocomplete-open");
      }
    });
  }

  function search(searchTerm) {
    var isFilteredSearch = false;
    var type = selectedUiItem ? selectedUiItem.type : ''
    if (!searchTerm) {
      searchTerm = $(".search_phrase").val();
    }
    else {
      isFilteredSearch = true;
    }
    $.ajax({
      url: "/api/Apptus/SearchUrlRedirect?search=" + encodeURIComponent(searchTerm) + "&searchMaskPrefix=" + type + "&isFilteredSearch=" + isFilteredSearch,

      async: true,
      type: "GET",
      contentType: "application/json",

      error: function (jqXHR, exception) {


        LogError(jqXHR, exception);
      },
      success: function (data) {
        if (data.IsSuccess) {
          window.location.href = data.RedirectUrl;
        }
      }
    });
  }

  function zeroSearchResultSubmit() {
    var zeroSearchForm = $('#zeroSearch');
    var data = zeroSearchForm.serialize();
    var email = zeroSearchForm.find("input#Email");
    var message = zeroSearchForm.find("textarea#Comment");



    var isValid = false;
    var regExpEmail = /^[a-z,A-Z,0-9_\+-]+(\.[a-z,A-Z,0-9_\+-]+)*@[a-z,A-Z,0-9-]+(\.[a-z,A-Z,0-9-]+)*\.([a-z,A-Z]{2,4})$/;
    if (email.val() != '') {
      isValid = true;
      email.removeClass("error");
    }
    else {
      isValid = false;
      email.addClass("error");
    }
    if (message.val() != '') {
      isValid = true;
      message.removeClass("error");
    }
    else {
      isValid = false;
      message.addClass("error");
    }

    if (isValid) {
      $.ajax({
        url: '/api/Apptus/ZeroSearchResult/',
        type: 'post',
        data: data,
        success: function () {
          $('#zeroSearchSubmitionResult').toggle();
          zeroSearchForm.toggle();
        }
      });
    }
  }
}